import { Controller } from "stimulus";

// Initializes select2 on any `.select2` / `.select2-multiple` field rendered inside a
// TurboModalComponent. `dropdownParent` is mandatory here: without it the dropdown is
// appended to <body>, where it renders behind the modal and Bootstrap's enforceFocus
// steals the focus from the search input (focusin outside .modal gets bounced back).
export default class extends Controller {
  connect() {
    // TurboModalComponent mounts this controller ON the .modal root itself, so the modal
    // is the element (a .find() would only reach descendants and always miss it).
    const modalElement = this.element.matches(".modal") ? this.element : this.element.querySelector(".modal");
    const options = modalElement ? { dropdownParent: $(modalElement) } : {};

    $(this.element).find(".select2").select2({
      ...options,
      placeholder: "-- selecione --",
      allowClear: true
    });

    $(this.element).find(".select2-multiple").select2({
      ...options,
      multiple: true,
      placeholder: "Todos(as)",
      allowClear: true
    });
  }

  disconnect() {
    $(this.element).find(".select2, .select2-multiple").each((_index, element) => {
      $(element).data("select2") && $(element).select2("destroy");
    });
  }
}
